<template>
  <div class="Alert" v-show="show && con">
    <div>{{con}}</div>
  </div>
</template>

<script>
var timer = null;
export default {
  props: ['con'],
  data () {
    return {
      show: false,
    }
  },
  watch: {
    con (val) {
      clearTimeout(timer)
      this.show = true;
      timer = setTimeout(() => {
        this.show = false;

      }, 1500);
    }
  },
}
</script>

<style scoped>
  .Alert{
    background: rgba(0,0,0,0.8);
    position: fixed;
    padding: 5px 20px;
    border-radius: 5px;
    top: 50%;
/*    width: 70%;*/
    left: 50%;
    white-space:nowrap;
    z-index: 1000;
    color: white;
    transform: translateX(-50%);
    text-align: center;
    z-index: 99999;
  }
</style>



// WEBPACK FOOTER //
// src/components/Alert.vue